import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { checkUserPermissions } from './utils';
import { IHasPermission } from './types';

export const HasPermission = (props: IHasPermission) => {
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();

  if (!userPermissions) return null;

  const hasPermission = checkUserPermissions({ userPermissions, props });

  return hasPermission ? <>{props.children}</> : null;
};
